import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {first} from 'rxjs/operators';
import {AuthService} from '../../../services/auth.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  error = false;
  loading = false;
  success = false;
  errorMsg: string;
  submitted = false;
  signInForm: FormGroup;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private pageTitleService: Title,
    private cookieService: CookieService
  ) { }

  // Convenience getter for easy access to form fields
  get f() { return this.signInForm.controls; }

  ngOnInit(): void {
    // check if user is logged in
    if (this.cookieService.get('token')) {
      this.router.navigateByUrl('/user/dashboard');
    }

    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Forgot Password');
    this.setFormControls();
  }

  setFormControls() {
    this.signInForm = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
      ])
    });
  }

  onSubmit() {
    this.submitted = true;
    // Stop here if there's form errors
    if (this.signInForm.invalid) {
      return;
    }
    this.loading = true;
    this.success = false;
    this.error = false;
    this.authService.forgotPassword(this.f.email.value)
      .pipe(first())
      .subscribe(
        data => {
          if (data.success) {
            this.success = true;
            setTimeout(() => {
              this.success = false;
            }, 4000);
          } else {
            this.error = true;
            this.errorMsg = data.error.msg;
            setTimeout(() => {
              this.error = false;
            }, 4000);
          }
          this.loading = false;
        },
        error => {
          this.error = true;
          this.loading = false;
        });
  }

}
